import produce from 'immer';
import {
  SET_USERS,
  GET_STORES_START,
  GET_STORES_SUCCESS,
  GET_STORES_FAILED,
  ADD_USER_STORE_START,
  ADD_USER_STORE_SUCCESS,
  ADD_USER_STORE_FAILED,
  DELETE_USER_STORE_START,
  DELETE_USER_STORE_SUCCESS,
  DELETE_USER_STORE_FAILED,
  DELETE_USER_START,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  DELETE_STORE_START,
  DELETE_STORE_SUCCESS,
  DELETE_STORE_FAILED,
  ADD_STORE_START,
  ADD_STORE_SUCCESS,
  ADD_STORE_FAILED,
  SAVE_EDITED_STORE_START,
  SAVE_EDITED_STORE_SUCCESS,
  SAVE_EDITED_STORE_FAILED,
  GET_ALL_PERMISSION_CONFIGS_START,
  GET_ALL_PERMISSION_CONFIGS_SUCCESS,
  GET_ALL_PERMISSION_CONFIGS_FAILED,
  CREATE_PERMISSION_CONFIG_START,
  CREATE_PERMISSION_CONFIG_SUCCESS,
  CREATE_PERMISSION_CONFIG_FAILED,
  UPDATE_PERMISSION_CONFIG_START,
  UPDATE_PERMISSION_CONFIG_SUCCESS,
  UPDATE_PERMISSION_CONFIG_FAILED,
  DELETE_PERMISSION_CONFIG_START,
  DELETE_PERMISSION_CONFIG_SUCCESS,
  DELETE_PERMISSION_CONFIG_FAILED,
  GET_CATALOG_STORE_CODES_START,
  GET_CATALOG_STORE_CODES_SUCCESS,
  GET_CATALOG_STORE_CODES_FAILED,
  CREATE_SM_USER_START,
  CREATE_SM_USER_SUCCESS,
  CREATE_SM_USER_FAILED,
  GET_SUBSCRIPTION_COUPON_CODES_START,
  GET_SUBSCRIPTION_COUPON_CODES_SUCCESS,
  GET_SUBSCRIPTION_COUPON_CODES_FAILED,
  CREATE_SUBSCRIPTION_COUPON_CODE_START,
  CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  CREATE_SUBSCRIPTION_COUPON_CODE_FAILED,
  UPDATE_SUBSCRIPTION_COUPON_CODE_START,
  UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED,
  DELETE_SUBSCRIPTION_COUPON_CODE_START,
  DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS,
  DELETE_SUBSCRIPTION_COUPON_CODE_FAILED,
  GET_STORE_TYPE_START,
  GET_STORE_TYPE_SUCCESS,
  GET_STORE_TYPE_FAILED,
  GET_SM_REPORT_EXPORT_START,
  GET_SM_REPORT_EXPORT_SUCCESS,
  GET_SM_REPORT_EXPORT_FAILED,
  GET_TOUCHMD_UPLOADS_START,
  GET_TOUCHMD_UPLOADS_SUCCESS,
  GET_TOUCHMD_UPLOADS_FAILED,
  GET_USERS_EXPORT_START,
  GET_USERS_EXPORT_SUCCESS,
  GET_USERS_EXPORT_FAILED,
} from '../actions/admin';
import {
  USER_PROFILE_UPDATE_START,
  USER_PROFILE_UPDATE_SUCCESS,
  USER_PROFILE_UPDATE_FAILED
} from '../actions/user';


const initialState = {
  isLoggedIn: false,
  loading: false,
  generalPermissions: {},
  permissionConfigs: [],
  updateUserProfile: false,
  error: '',
  users: [],
  usersEmailAutocomplete: [],
  usersTotalCount: 0,
  stores: [],
  storesTotalCount: 0,
  touchMdUploads: [],
  touchMdTotalCount: 20,
  touchMdUploadsLoading: false,
  catalogStoreCodes: [],
  subscriptionCouponCodes: [],
  loadingCouponCodes: false,
  magentoStoreType: '',
  loadingMagentoStoreType: false,
  loadPermissionConfigs: false,
  loadingSMReport: false,
  downloadingUsersReport: false
};


const formReducer = produce((state: IAdminState = initialState, action) => {
  switch (action.type) {
    case SET_USERS: {
      const {data, autocomplete} = action;

      if (autocomplete) {
        state.usersEmailAutocomplete = data.users;
      } else {
        state.users = data.users;
        state.usersTotalCount = data.totalCount;
      }

      break;
    }

    case GET_STORES_START: {
      state.loading = true;
      break;
    }

    case GET_STORES_SUCCESS: {
      const {data} = action;
      state.stores = data.stores;
      state.storesTotalCount = data.totalCount;
      state.loading = false;
      break;
    }

    case GET_STORES_FAILED: {
      state.loading = false;
      break;
    }

    case GET_USERS_EXPORT_START: {
      state.downloadingUsersReport = true;
      break;
    }

    case GET_USERS_EXPORT_SUCCESS: {
      state.downloadingUsersReport = false;
      break;
    }

    case GET_USERS_EXPORT_FAILED: {
      state.downloadingUsersReport = false;
      break;
    }

    case ADD_USER_STORE_START: {
      state.loading = true;
      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      const {userEmail, store} = action.data;

      const user = state.users.find((user) => user.email == userEmail);

      if (user) {
        user.stores.unshift(store);
      }

      state.loading = false;
      break;
    }

    case ADD_USER_STORE_FAILED: {
      state.loading = false;
      break;
    }

    case DELETE_USER_STORE_START: {
      state.loading = true;
      break;
    }

    case DELETE_USER_STORE_SUCCESS: {
      const {apiUrl, email} = action.data;
      state.users = state.users.map((item) => {
        if (item.email == email) {
          item.stores = item.stores.filter((item) => item.apiUrl !== apiUrl);
          return item;
        }

        return item;
      });

      state.loading = false;
      break;
    }

    case DELETE_USER_STORE_FAILED: {
      state.loading = false;
      break;
    }

    case DELETE_USER_START: {
      state.loading = true;
      break;
    }

    case DELETE_USER_SUCCESS: {
      const email = action.data;
      state.users = state.users.filter((item) => item.email !== email);
      state.loading = false;
      break;
    }

    case DELETE_USER_FAILED: {
      state.loading = false;
      break;
    }

    case DELETE_STORE_START: {
      state.loading = true;
      break;
    }

    case DELETE_STORE_SUCCESS: {
      const storeId = action.id;
      state.stores = state.stores.filter((item) => item._id !== storeId);
      state.loading = false;
      break;
    }

    case DELETE_STORE_FAILED: {
      state.loading = false;
      break;
    }

    case ADD_STORE_START: {
      state.loading = true;
      break;
    }

    case ADD_STORE_SUCCESS: {
      const {store} = action;
      state.stores.push(store);
      state.loading = false;
      break;
    }

    case ADD_STORE_FAILED: {
      state.loading = false;
      break;
    }

    case SAVE_EDITED_STORE_SUCCESS: {
      const {store} = action.data;
      state.stores = state.stores.map((item) => item._id === store._id ? store : item);
      state.loading = false;
      break;
    }

    case SAVE_EDITED_STORE_FAILED: {
      state.loading = false;
      break;
    }

    case SAVE_EDITED_STORE_START: {
      state.loading = true;
      break;
    }

    case GET_ALL_PERMISSION_CONFIGS_START: {
      state.loadPermissionConfigs = true;
      break;
    }
    case GET_ALL_PERMISSION_CONFIGS_SUCCESS: {
      state.permissionConfigs = action.configs;
      const generalConfig = action.configs.find((c) => c.type === 'general') || {};

      if (generalConfig.permissions) {
        state.generalPermissions = generalConfig.permissions;
      }

      state.loadPermissionConfigs = false;
      break;
    }
    case GET_ALL_PERMISSION_CONFIGS_FAILED: {
      state.loadPermissionConfigs = false;
      break;
    }

    case CREATE_PERMISSION_CONFIG_START: {
      state.loadPermissionConfigs = true;
      break;
    }
    case CREATE_PERMISSION_CONFIG_SUCCESS: {
      const { config } = action.data;
      state.permissionConfigs = [...state.permissionConfigs, config];
      state.loadPermissionConfigs = false;
      break;
    }
    case CREATE_PERMISSION_CONFIG_FAILED: {
      state.loadPermissionConfigs = false;
      break;
    }

    case UPDATE_PERMISSION_CONFIG_START: {
      state.loadPermissionConfigs = true;
      break;
    }
    case UPDATE_PERMISSION_CONFIG_SUCCESS: {
      const { config } = action.data;

      const updatedConfigs = state.permissionConfigs.map((c) => c._id === config._id ? config : c);

      state.permissionConfigs = updatedConfigs;
      state.loadPermissionConfigs = false;
      break;
    }
    case UPDATE_PERMISSION_CONFIG_FAILED: {
      state.loadPermissionConfigs = false;
      break;
    }

    case DELETE_PERMISSION_CONFIG_START: {
      state.loadPermissionConfigs = true;
      break;
    }
    case DELETE_PERMISSION_CONFIG_SUCCESS: {
      const { id } = action;
      state.permissionConfigs = state.permissionConfigs.filter((c) => c._id !== id);
      state.loadPermissionConfigs = false;
      break;
    }
    case DELETE_PERMISSION_CONFIG_FAILED: {
      state.loadPermissionConfigs = false;
      break;
    }

    case USER_PROFILE_UPDATE_START: {
      state.updateUserProfile = true;
      break;
    }

    case USER_PROFILE_UPDATE_SUCCESS: {
      const { data } = action;
      state.users = state.users.map((user) => {
        if (user._id === data.user._id) {
          user = {...user, ...data.user };
        }

        return user;
      });

      state.updateUserProfile = false;
      break;
    }

    case USER_PROFILE_UPDATE_FAILED: {
      state.updateUserProfile = false;
      break;
    }

    case GET_CATALOG_STORE_CODES_START: {
      state.loading = true;
      break;
    }

    case GET_CATALOG_STORE_CODES_SUCCESS: {
      const { data } = action;

      state.catalogStoreCodes = data;
      state.loading = false;

      break;
    }

    case GET_CATALOG_STORE_CODES_FAILED: {
      state.loading = false;
      break;
    }


    case CREATE_SM_USER_START: {
      state.loading = true;
      break;
    }

    case CREATE_SM_USER_SUCCESS: {
      const { user } = action.data;
      state.users = [...state.users, user];
      state.loading = false;
      break;
    }

    case CREATE_SM_USER_FAILED: {
      state.loading = false;
      break;
    }

    case GET_SUBSCRIPTION_COUPON_CODES_START: {
      state.loadingCouponCodes = true;
      break;
    }

    case GET_SUBSCRIPTION_COUPON_CODES_SUCCESS: {
      const { subscriptionCouponCodes } = action.data;
      state.subscriptionCouponCodes = subscriptionCouponCodes;
      state.loadingCouponCodes = false;
      break;
    }

    case GET_SUBSCRIPTION_COUPON_CODES_FAILED: {
      state.loadingCouponCodes = false;
      break;
    }

    case CREATE_SUBSCRIPTION_COUPON_CODE_START: {
      state.loadingCouponCodes = true;
      break;
    }

    case CREATE_SUBSCRIPTION_COUPON_CODE_SUCCESS: {
      const { subscriptionCouponCode } = action.data;
      state.subscriptionCouponCodes = [subscriptionCouponCode, ...state.subscriptionCouponCodes];
      state.loadingCouponCodes = false;
      break;
    }

    case CREATE_SUBSCRIPTION_COUPON_CODE_FAILED: {
      state.loadingCouponCodes = false;
      break;
    }

    case UPDATE_SUBSCRIPTION_COUPON_CODE_START: {
      state.loadingCouponCodes = true;
      break;
    }

    case UPDATE_SUBSCRIPTION_COUPON_CODE_SUCCESS: {
      const { subscriptionCouponCode } = action.data;
      state.subscriptionCouponCodes = state.subscriptionCouponCodes
        .map((code) => code._id === subscriptionCouponCode._id
          ? subscriptionCouponCode
          : code
        );
      state.loadingCouponCodes = false;
      break;
    }

    case UPDATE_SUBSCRIPTION_COUPON_CODE_FAILED: {
      state.loadingCouponCodes = false;
      break;
    }

    case DELETE_SUBSCRIPTION_COUPON_CODE_START: {
      state.loadingCouponCodes = true;
      break;
    }

    case DELETE_SUBSCRIPTION_COUPON_CODE_SUCCESS: {
      const { id } = action;
      state.subscriptionCouponCodes = state.subscriptionCouponCodes
        .filter((code) => code._id !== id);
      state.loadingCouponCodes = false;
      break;
    }

    case DELETE_SUBSCRIPTION_COUPON_CODE_FAILED: {
      state.loadingCouponCodes = false;
      break;
    }

    case GET_STORE_TYPE_START: {
      state.loadingMagentoStoreType = true;
      break;
    }

    case GET_STORE_TYPE_SUCCESS: {
      const { config } = action.data;
      state.magentoStoreType = config[0].value;
      state.loadingMagentoStoreType = false;
      break;
    }

    case GET_STORE_TYPE_FAILED: {
      state.loadingMagentoStoreType = false;
      break;
    }

    case GET_SM_REPORT_EXPORT_START: {
      state.loadingSMReport = true;
      break;
    }
    case GET_SM_REPORT_EXPORT_SUCCESS: {
      state.loadingSMReport = false;
      break;
    }
    case GET_SM_REPORT_EXPORT_FAILED: {
      state.loadingSMReport = false;
      break;
    }

    case GET_TOUCHMD_UPLOADS_START: {
      state.touchMdUploadsLoading = true;
      break;
    }

    case GET_TOUCHMD_UPLOADS_SUCCESS: {
      const {data} = action;
      state.touchMdUploads = data.data;
      state.touchMdTotalCount = data.totalCount;
      state.touchMdUploadsLoading = false;
      break;
    }

    case GET_TOUCHMD_UPLOADS_FAILED: {
      state.touchMdUploadsLoading = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
